/** Eureka 全部历史服务。 */
export interface EurekaAllHistoryService {
    /**
     * 获取当前账号的全部历史任务总数。
     * @returns Eureka 全部历史接口返回的任务总数。
     */
    getHistoryTotal(): Promise<number>;
    /**
     * 判断当前账号是否存在任意历史任务。
     * @returns 存在至少一条历史任务时返回 true。
     */
    hasHistory(): Promise<boolean>;
}

/** Eureka 全部历史服务的容器标识。 */
export const EurekaAllHistoryService = Symbol('EurekaAllHistoryService');
